import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b5a4f2f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "outContainer" }
const _hoisted_2 = { class: "container" }

import { Row, Col, } from 'ant-design-vue';
import Header from '@/components/header/index.vue';
import Banner from './components/banner/index.vue';
import Ranking from './components/ranking/index.vue';
import Guide from './components/guide/index.vue';
import Forecast from './components/forecast/index.vue';
import Leaflet from './components/leaflet/index.vue';
import Footer from '@/components/footer/index.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(Banner),
      _createVNode(_unref(Row), null, {
        default: _withCtx(() => [
          _createVNode(_unref(Col), {
            lg: 7,
            xs: 24
          }, {
            default: _withCtx(() => [
              _createVNode(Ranking)
            ]),
            _: 1
          }),
          _createVNode(_unref(Col), {
            lg: 17,
            xs: 24
          }, {
            default: _withCtx(() => [
              _createVNode(Guide)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(Forecast),
      _createVNode(Leaflet)
    ]),
    _createVNode(Footer)
  ]))
}
}

})